import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';

const DEFAULT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const RevenueGrowthOne = ({ societyIncrement }) => {
    const monthlySeries = societyIncrement?.monthlySeries || [];
    const currentMonth = societyIncrement?.currentMonth ?? 0;

    const { categories, values } = useMemo(() => {
        if (monthlySeries.length) {
            return {
                categories: monthlySeries.map((m) => m.month),
                values: monthlySeries.map((m) => Number(m.value) || 0),
            };
        }
        return { categories: DEFAULT_MONTHS, values: new Array(12).fill(0) };
    }, [monthlySeries]);

    const chartColor = '#487fff';

    const options = {
        chart: { type: 'area', toolbar: { show: false } },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 4, colors: [chartColor], lineCap: 'round' },
        fill: {
            type: 'gradient',
            colors: [chartColor],
            gradient: {
                shade: 'light',
                type: 'vertical',
                shadeIntensity: 0.5,
                gradientToColors: [`${chartColor}00`],
                opacityFrom: 0.6,
                opacityTo: 0.3,
                stops: [0, 100],
            },
        },
        markers: { colors: [chartColor], strokeWidth: 3, size: 0, hover: { size: 10 } },
        xaxis: { categories, labels: { style: { fontSize: '14px' } } },
        yaxis: { labels: { show: false } },
        grid: { borderColor: '#e0e0e0' },
        tooltip: { y: { formatter: (v) => v.toLocaleString('en-IN') } },
    };

    const series = [{ name: 'New Societies', data: values }];

    return (
        <div className="col-xxl-4">
            <div className="card h-100 radius-8 border">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <div>
                            <h6 className="mb-2 fw-bold text-lg">Society Increment</h6>
                            <span className="text-sm fw-medium text-secondary-light">
                                Current Month Report
                            </span>
                        </div>
                        <div className="text-end">
                            <h6 className="bg-success-focus ps-12 pe-12 pt-2 pb-2 rounded-2 fw-medium text-success-main">
                                {currentMonth.toLocaleString('en-IN')}
                            </h6>
                        </div>
                    </div>
                    <div id="revenue-chart" className="mt-28">
                        <ReactApexChart options={options} series={series} type="area" height={162} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RevenueGrowthOne;
